import React from "react";
import "./CustomCancellationReturnPolicyModal.css";
import Icons from "../../../../Config/Images";
const CustomCancellationReturnPolicyModal = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null; // Don't render if modal is closed

  return (
    <div className="modal-overlay-cancellation-return" onClick={onClose}>
      <div>
        <div
          className="modal-content-cancellation-return"
          onClick={(e) => e.stopPropagation()}
          style={{position:"relative"}}
        >
          <div className="cross-close-icon">
            <img onClick={onClose} src={Icons.cross_icon} alt="" />
          </div>
          <h2 className="modal-title-cancellation-return">
          Cancellation, Return & Refund Policy
          </h2>
          <div className="modal-body-cancellation-return">{content}</div>
          {/* <button
          className="modal-close-btn-cancellation-return"
          onClick={onClose}
        >
          Close
        </button> */}
        </div>
      </div>
    </div>
  );
};

export default CustomCancellationReturnPolicyModal;
